module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [(_vm.lAction === 'view') ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "mx-auto": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "px-0 py-0"
  }, [_c('v-text-field', {
    staticClass: "pt-0",
    attrs: {
      "append-icon": "search",
      "placeholder": _vm.$vuetify.breakpoint.smAndUp ? 'Search by Vendor Supplier Name, Service Capability, etc.' : 'Search',
      "hide-details": "",
      "outlined": "",
      "clearable": ""
    },
    model: {
      value: (_vm.searchVendorSupplier),
      callback: function($$v) {
        _vm.searchVendorSupplier = $$v
      },
      expression: "searchVendorSupplier"
    }
  })], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "px-0 pt-2"
  }, [_c('v-data-table', {
    staticClass: "elevation-3",
    attrs: {
      "headers": _vm.vendorSupplierListHeader,
      "items": _vm.vendorSupplierList,
      "hide-actions": "",
      "mobile-breakpoint": 0,
      "fixed-header": "",
      "dense": "",
      "search": _vm.searchVendorSupplier
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(ref) {
        var headers = ref.props.headers;

        return [_c('thead', [_c('tr', [_c('th', {
          staticStyle: {
            "font-size": "17px",
            "width": "50px",
            "text-align": "center"
          }
        }, [_vm._v(_vm._s(headers[0].text))]), _vm._v(" "), _c('th', {
          staticStyle: {
            "font-size": "17px",
            "width": "140px",
            "text-align": "left"
          }
        }, [_vm._v(_vm._s(headers[1].text))]), _vm._v(" "), _c('th', {
          staticStyle: {
            "font-size": "17px",
            "width": "120px",
            "text-align": "left"
          }
        }, [_vm._v(_vm._s(headers[2].text))]), _vm._v(" "), _c('th', {
          staticStyle: {
            "font-size": "13px",
            "width": "120px",
            "text-align": "left"
          }
        }, [_vm._v(_vm._s(headers[3].text))]), _vm._v(" "), _c('th', {
          staticStyle: {
            "font-size": "13px",
            "width": "300px",
            "text-align": "left"
          }
        }, [_vm._v(_vm._s(headers[4].text))]), _vm._v(" "), _c('th', {
          staticStyle: {
            "font-size": "13px",
            "width": "120px",
            "text-align": "center"
          }
        }, [_vm._v(_vm._s(headers[5].text))])])])]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_vm._v(" " + _vm._s(props.index + 1) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(props.item.vendorsupplier_name ? props.item.vendorsupplier_name : '-') + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(props.item.contact_name ? props.item.contact_name : '-') + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(props.item.contact_phone ? props.item.contact_phone : '-') + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(props.item.service_capability ? props.item.service_capability : '-') + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(props.item.city ? props.item.city : '-') + " ")])])]
      }
    }], null, false, 253846644)
  })], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79163739","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VendorSupplierBO.vue
// module id = 810
// module chunks = 12